export const CURRENCIES_RESET_STATE = 'CURRENCIES_RESET_STATE';
export const CURRENCIES_CURRENT_ITEM = 'CURRENCIES_CURRENT_ITEM';

export const CURRENCIES_REQUEST_LOADING = 'CURRENCIES_REQUEST_LOADING';
export const CURRENCIES_REQUEST_SUCCESS = 'CURRENCIES_REQUEST_SUCCESS';
export const CURRENCIES_REQUEST_FAILED = 'CURRENCIES_REQUEST_FAILED';

export const CURRENCIES_CURRENT_ACTION = 'CURRENCIES_CURRENT_ACTION';
export const CURRENCIES_RESET_ACTION = 'CURRENCIES_RESET_ACTION';